import type { ApiError } from './apiError.types';

/**
 * Type guard to check if error is ApiError
 * @param error - Unknown error object
 * @returns True if error is ApiError
 */
export function isApiError(error: unknown): error is ApiError {
  if (typeof error !== 'object' || error === null) return false;
  const obj = error as Record<string, unknown>;
  return (
    typeof obj.status === 'number' &&
    Array.isArray(obj.errors) &&
    obj.errors.every((e) => typeof e === 'object' && e !== null)
  );
}
